import { render, staticRenderFns } from "./KarmaProgramEdit.vue?vue&type=template&id=4b493306&"
import script from "./KarmaProgramEdit.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramEdit.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports